import { Card } from 'flowbite-react'
import React, { useEffect } from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import * as styles from './twoFALogin.styles'
import Form from '../../components/Form/Form'
import CustomButton from '../../components/CustomButton/CustomButton'
import CustomLink from '../../components/CustomLinks/CustomLink'
import bottomLines from '../../assets/botton lines.png'
import PublicLayout from '../../layouts/PublicLayout'
import { maskEmail } from '../../utils/commonHelper'
import client from '../../api/client'
import showToast from '../../components/CustomToast/toastHelper'
import { getEnvironment } from '../../utils/getEnvironmentConfig'

const TwoFALogin = () => {
  const location = useLocation();
  const navigate = useNavigate();

  let email = location.state?.email ?? sessionStorage.getItem("email");
  const env = getEnvironment()  
  
  useEffect(()=>{
    if(!email) navigate('/login')
  },[email, navigate])
  if (!email) {
    return null;
  }
  const maskedEmail = maskEmail(email)

  const handleLinkResend =async(e:any)=>{
    e.preventDefault()
    try {
      const response = await client.get(`/subsidiary/dashboard/resend/verification/email?Email=${email}`);
      if (response.data.status === "success") {
          
          showToast(response.data.message,"success")
      } else {
          showToast(response.data.message,"error")
      }
  } catch (err:any) {
      console.error('Error saving business details', err);
      showToast(err.response.data.message,"error")
  }
  }
  return (
    <PublicLayout>
    <div className={styles.container}>
      <Card className={styles.card}>
        <Form title="" subtitle="">
          <div className={styles.headerMessageDiv}>
            <p className={styles.headerMessage}>An email has been sent to your email address - {maskedEmail}, verify to sign in</p>
          </div>
          {env =="DEV" &&<CustomButton className={styles.verifyButton} text='Verify Test Mode' icon={<FaArrowRight />} />}
          <CustomButton className={styles.resendButton} onClick={handleLinkResend} text='Resend Link' icon={<FaArrowRight />} />
          <div className={styles.buttomDiv}>
            <p className={styles.buttomDivPara}>Email already verified?
              <CustomLink className={styles.linkText} to="/login" text=" Login" />
            </p>
          </div>

        </Form>

      </Card>
      
    </div>
    </PublicLayout>
  )
}

export default TwoFALogin
